export default __webpack_public_path__ + "static/media/more-plus.f51d4961.svg";